import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store'
import type { Role } from '@/types'

const ROLE_DASHBOARD: Record<Role, string> = {
  ultraadmin: '/ultraadmin/dashboard',
  superadmin: '/superadmin/dashboard',
  admin: '/admin/substitutions',
  hr: '/hr',
  director: '/director/dashboard',
  teacher: '/teacher/dashboard',
  engineer: '/messages',
  partner: '/partner/schools',
}

export function DashboardPage() {
  const { user, isLoading } = useAuthStore()

  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen"><p className="text-gray-500">Laden...</p></div>
  }

  const role = user?.role ?? 'teacher'

  if (role === 'hr') return <Navigate to="/hr" replace />

  const dashboardPath = ROLE_DASHBOARD[role] ?? ROLE_DASHBOARD.teacher

  return <Navigate to={dashboardPath} replace />
}
